export class SubCategory{
    constructor(subCategoryId,subCategoryName,subCategoryArabicName,images){
        this.subCategoryId = subCategoryId
        this.subCategoryName = subCategoryName
        this.subCategoryArabicName = subCategoryArabicName
        this.images = images
    }
}